export default "__VITE_ASSET__cb8bfd2a__"